module.exports = __webpack_public_path__ + "assets/img/tg.87014465.svg";